import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const TagContainer = styled.div`
    & div {
        width: fit-content;
    }
`;

export const DeleteDrawContainer = styled.div`
    z-index: 1000;
`;

export const FiltersLabel = styled.label`
    width: 100%;
`;

export const ToogleButton = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    float: right;
    border: 0;
    cursor: pointer;
    font-size: ${theme.font.size16};
    font-weight: bold;
    color: #EC6E0C;
    background-color: transparent;

    svg {
        margin-right: 8px;
    }
`;

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 960px) {
        flex-direction: column;
        align-items: end;
    }
`;

export const Row = styled.div`
    display: flex;
    gap: 24px;

    @media (max-width: 960px) {
        flex-direction: column;
        gap: 0;
        width: 100%;
    }
`;

export const FirstColumn = styled.div`
    margin: 0 24px 0 0;
    width: 100%;

    @media (max-width: 960px) {
        margin: 0;
    }

    ${({ showFilters }) => !showFilters && `display: none;`}
`;

export const SecondColumn = styled.div`
    display:flex;
    align-items:flex-end;
    margin: 0 0 24px 0;

    @media (max-width: 960px) {
        width: 100%;
        
        & button {
            width: 100%;
        }
    }

    ${({ showFilters }) => !showFilters && `display: none;`}
`;

export const AlignIputs = styled.div`
    display:flex;
    justify-content: space-between;
`;

export const InputSpacing = styled.div`
    width:100%;
`;

export const InputSpacingMiddle = styled.div`
    width:100%;
    padding: 0 24px;
`;

export const TextoResultado = styled.div`
    margin: 8px 0px 16px;
    font-size: ${theme.font.size20};
    font-weight: bold;
    color: ${(props) => props.theme.black};
`;

export const TableSpacing = styled.div`
    margin: 0 32px;
`;

export const TableContainer = styled.div`
    margin: 0 32px;

    .in-analysis-pending-move > td:not(.status-column) {
        color: ${(props) => props.grey} !important;

        ${({ contrastTheme }) => (contrastTheme ? `opacity: 1 !important;` : `opacity: 0.4 !important;`)};
    }
`;

export const TableContent = styled.div`
    display: flex;
    justify-content: center;
`;
